import { configureStore } from '@reduxjs/toolkit';
import { bookInfoReducer } from './book.slice';
import { cartReducer }  from './cart.slice';
import { hydrationReducer } from './hydration.slice';

// Preloaded state is intentionally left as the reducers' own defaults here.
// Persisted cart/bkInfo is loaded from localStorage after mount (see _app.js)
// so the server-rendered HTML and the client's first render always match —
// reading localStorage at module scope caused hydration mismatches, since
// this module runs during SSR (no localStorage) and in the browser (has it).
const store = configureStore({
      reducer: {
        cart: cartReducer.reducer,
        bkInfo : bookInfoReducer.reducer,
        hasHydrated: hydrationReducer.reducer,
    },
});
store.subscribe(() => {
    if (typeof window === 'undefined') return;
    const cart = store.getState().cart;
    const bkInfo = store.getState().bkInfo;
    localStorage.setItem('rxState', JSON.stringify({ cart: cart }));
    localStorage.setItem('bkState', JSON.stringify(bkInfo));
});

export default store;
